import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-city-evaluation-fusilli-impacts',
  templateUrl: './city-evaluation-fusilli-impacts.component.html',
  styleUrls: ['./city-evaluation-fusilli-impacts.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CityEvaluationFusilliImpactsComponent implements OnInit {
  
  public city = history.state.city;
  public expanded: boolean = false;
  public data: any = [];
  public impactObjects: any = [];
  public currentMouseover: number | null = null;

  constructor(private req: HttpRequestsService<any>) { }

  ngOnInit(): void {
    this.req.getCityImpacts(this.city).subscribe((res) => {
      this.data = res;
      this.data.forEach(element => {
        element.expanded = false;
      })
    });
  }

  onClick(index: number): void {
    this.data.forEach((item, i) => {
      if (i !== index) {
        item.expanded = false
      }
    });

    this.data[index].expanded = !this.data[index].expanded;
  }

  buttonMouseover(impact: number): void {
    this.currentMouseover = impact;
  }

  buttonLeave(): void {
    this.currentMouseover = null;
  }
}
